import { styled } from '@mui/material';

export const Count = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginTop: theme.spacing(0.5),
}));

export const OfTotal = styled('span')(({ theme }) => ({
  color: theme.supportingTextPrimary,
  fontSize: '0.75rem',
}));

export const Container = styled('div')({
  display: 'flex',
  position: 'relative',
});

export const ControlContainer = styled('div')({
  alignItems: 'center',
  display: 'flex',
});

export const ImageContainer = styled('div')({
  flexGrow: 1,
});
